const employment = {
  apiPath: '/api/sync-employment',
  canRevert: false
}

const menu = {
  apiPath: '/api/sync-locations',
  canRevert: true
}

export function publishBehavior (blobType) {
  switch (blobType) {
    case 'employment':
      return employment
    case 'menu':
    default:
      return menu
  }
}

export function isValidBlobType (blobType) {
  return ['menu', 'employment'].includes(blobType)
}
